import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./components/LanguageContext";
import MainLayout from "./layouts/MainLayout";
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import SocialMediaMarketingPage from "./pages/SocialMediaMarketingPage";
import GeoSolutionsPage from "./pages/GeoSolutionsPage";
import SearchAdsMediaOutreach from "./components/pages/SearchAdsMediaOutreach";
// Switch between MDX and WordPress versions
// import NewsMarketInsights from "./components/NewsMarketInsights"; // MDX version
import NewsMarketInsights from "./components/pages/NewsMarketInsightsWordPress"; // WordPress version
// import ArticleDetail from "./pages/ArticleDetail"; // MDX version
import ArticleDetail from "./pages/ArticleDetailWordPress"; // WordPress version
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import TermsOfUse from "./components/legal/TermsOfUse";
import NihaoBridgeThPage from "./pages/NihaoBridgeThPage";
import NihaoBridgeVnPage from "./pages/NihaoBridgeVnPage";
// TEMPORARY: Cookie Policy import disabled (Update #14 - 2025-08-20)
// import CookiePolicy from "./components/legal/CookiePolicy";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path="about-us" element={<AboutUsPage />} />
            <Route path="technology-marketing-solutions" element={<SocialMediaMarketingPage />} />
            <Route path="geo-solutions" element={<GeoSolutionsPage />} />
            <Route path="chinese-search-ads-media-outreach" element={<SearchAdsMediaOutreach />} />
            <Route path="market-insights" element={<NewsMarketInsights />} />
            <Route path="insights/:id" element={<ArticleDetail />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms-of-use" element={<TermsOfUse />} />
            <Route path="nihao-bridge/th" element={<NihaoBridgeThPage />} />
            <Route path="nihao-bridge/vn" element={<NihaoBridgeVnPage />} />
            {/* TEMPORARY: Cookie Policy route disabled (Update #14 - 2025-08-20) */}
            {/* Original route - uncomment to re-enable Cookie Policy page
            <Route path="cookie-policy" element={<CookiePolicy />} />
            */}
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;